import { defineMessages } from 'react-intl';

export default defineMessages({
  searchPlaceholder: {
    id: 'view.nav.items.search',
    defaultMessage: 'Search',
  },
  filter: {
    id: 'general.datable.filterButton',
    defaultMessage: 'Filter',
  },
  filterHeading: {
    id: 'general.datable.filterHeading',
    defaultMessage: 'Filters',
  },
  closePanel: {
    id: 'general.datable.closePanel',
    defaultMessage: 'Close',
  },
  resetFilters: {
    id: 'general.datable.resetFilters',
    defaultMessage: 'Reset',
  },
  showResult: {
    id: 'general.datable.showResult',
    defaultMessage: 'Show results',
  },
  allSelected: {
    id: 'general.datable.allSelected',
    defaultMessage: 'All',
  },
  selectFilters: {
    id: 'general.datable.selectFilters',
    defaultMessage: 'Select your filter',
  },
  maxMustBeMoreThanMin: {
    id: 'general.datable.maxMustBeMoreThanMin',
    defaultMessage: "Max value isn't more than min",
  },
});
